import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import ConditionalTooltip from '../../ConditionalTooltip';
import Editor, { TABLE_CELL_COMPONENT, NOT_APPLICABLE } from '../Editor';
import './ShortStringEditor.scss';

const DEFAULT_MAX_LENGTH = 11;

const getShortString = (s, maxLength) => {
  if (!s || (s.length <= maxLength)) {
    return s || '';
  }
  return `${s.substring(0, DEFAULT_MAX_LENGTH - 3)}...`;
};

class ShortStringComponent extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    editing: PropTypes.bool,
    label: PropTypes.string,
    type: PropTypes.string,
    error: PropTypes.string,
    readOnly: PropTypes.bool,
  }

  static defaultProps = {
    value: undefined,
    error: null,
    readOnly: false,
    label: null,
    editing: false,
    type: 'string',
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event) => {
    const { onChange, type } = this.props;
    if (onChange) {
      let { value } = event.target;
      if (type === 'integer') {
        value = parseInt(value, 10);
      } else if (type === 'number') {
        value = parseFloat(value);
      }
      onChange(value);
    }
  };

  render() {
    const {
      value,
      editing,
      error,
      label,
      readOnly,
      type,
    } = this.props;
    const numeric = (type === 'number' || type === 'integer');
    const displayValue = !editing && getShortString(value, DEFAULT_MAX_LENGTH);
    return (
      <div className="tuc-sort-textfield-editor">
        {editing ? (
          <TextField
            error={!!error}
            label={error || label}
            value={value || ''}
            type={numeric ? 'number' : undefined}
            margin="dense"
            onChange={this.handleChange}
            disabled={readOnly}
          />
        ) : (
          <ConditionalTooltip title={value === displayValue ? null : value}>
            {displayValue}
          </ConditionalTooltip>
        )}
      </div>
    );
  }
}

export default class ShortStringEditor extends Editor {
  constructor(name, components) {
    super(name || 'shortstring',
      Object.assign({}, { [TABLE_CELL_COMPONENT]: [ShortStringComponent, ShortStringComponent] }, components));
  }

  getFilterValue(value) {
    return value;
  }

  formatValue(value, data, propName, props = {}) {
    return value === undefined
        ? NOT_APPLICABLE : getShortString(value, props.maxLength || DEFAULT_MAX_LENGTH);
  }
}
